export default __webpack_public_path__ + "static/media/save-content.0732379a.svg";